// QtySelector — selector de cantidad − [n] + de la tienda v5.
// Fuente: maquetas (producto-detalle es la referencia: botones 40×44).
// En checkout, con trashAtMin, cuando value === min el "−" se transforma en papelera roja.
//
// Self-contained: <style>{QTY_CSS}</style> + clases .tv5-qty-* + tokens --tv5-* propios.
//
// Props:
//   value       número            → cantidad actual (controlado)
//   min         número            → mínimo (default 1)
//   max         número            → máximo (default 99)
//   onChange    (nuevaCant)=>{}    → callback al cambiar la cantidad
//   trashAtMin  boolean           → si true, en value===min el "−" es papelera (default false)
//   onRemove    ()=>{}            → callback al tocar la papelera (solo si trashAtMin)

const QTY_CSS = `
.tv5-qty {
  --tv5-teal:#00A8B5; --tv5-text:#F8F6F1; --tv5-border:rgba(255,255,255,0.08);
  display:inline-flex; align-items:center; background:rgba(255,255,255,0.05);
  border:1px solid var(--tv5-border); border-radius:12px; overflow:hidden;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.tv5-qty-btn { width:40px; height:44px; background:transparent; border:0; color:var(--tv5-text);
  font-size:18px; font-weight:700; cursor:pointer; display:flex; align-items:center; justify-content:center;
  transition:all 0.15s; -webkit-tap-highlight-color:transparent; }
.tv5-qty-btn:disabled { opacity:0.35; cursor:default; }
.tv5-qty-btn.trash { color:#F87171; font-size:16px; }
.tv5-qty-btn.trash:active { color:#EF4444; background:rgba(239,68,68,0.14); }
.tv5-qty-val { min-width:44px; height:44px; display:flex; align-items:center; justify-content:center;
  color:var(--tv5-text); font-size:15px; font-weight:800; text-align:center; }
@media (hover:hover){
  .tv5-qty-btn:not(:disabled):not(.trash):hover { background:rgba(255,255,255,0.05); color:var(--tv5-teal); }
  .tv5-qty-btn.trash:hover { color:#EF4444; background:rgba(239,68,68,0.14); }
}
`;

export function QtySelector({ value = 1, min = 1, max = 99, onChange, trashAtMin = false, onRemove }) {
  const atMin = value <= min;
  const esTrash = atMin && trashAtMin;

  function menos() {
    if (esTrash) { onRemove && onRemove(); return; }
    if (value > min) onChange && onChange(value - 1);
  }
  function mas() {
    if (value < max) onChange && onChange(value + 1);
  }

  return (
    <div className="tv5-qty">
      <style>{QTY_CSS}</style>
      <button
        className={'tv5-qty-btn' + (esTrash ? ' trash' : '')}
        onClick={menos}
        disabled={atMin && !trashAtMin}
        aria-label={esTrash ? 'Eliminar' : 'Menos'}
      >{esTrash ? '🗑' : '−'}</button>
      <span className="tv5-qty-val" aria-live="polite">{value}</span>
      <button className="tv5-qty-btn" onClick={mas} disabled={value >= max} aria-label="Más">+</button>
    </div>
  );
}
